import { formatPaperDate } from "../../PracticePapers/utils/formatPaperTime"

const MINUTE = 60 * 1000
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

/** Naive ISO timestamps from the API are UTC (`datetime.utcnow()`). */
export const parseNoteDate = (iso: string): Date => {
  const trimmed = iso.trim()
  if (/[zZ]$/.test(trimmed) || /[+-]\d{2}:?\d{2}$/.test(trimmed)) {
    return new Date(trimmed)
  }
  return new Date(`${trimmed}Z`)
}

export const formatNoteDate = (iso: string | null | undefined): string => {
  if (!iso) return ""
  const then = parseNoteDate(iso)
  if (Number.isNaN(then.getTime())) return ""
  const delta = Date.now() - then.getTime()
  if (delta < MINUTE) return "Just now"
  if (delta < HOUR) {
    const minutes = Math.max(1, Math.round(delta / MINUTE))
    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`
  }
  if (delta < DAY) {
    const hours = Math.max(1, Math.round(delta / HOUR))
    return `${hours} hour${hours === 1 ? "" : "s"} ago`
  }
  const startOfToday = new Date()
  startOfToday.setHours(0, 0, 0, 0)
  const startOfThen = new Date(then)
  startOfThen.setHours(0, 0, 0, 0)
  const dayDiff = Math.round(
    (startOfToday.getTime() - startOfThen.getTime()) / DAY
  )
  if (dayDiff === 1) return "Yesterday"
  return formatPaperDate(then.toISOString())
}
